/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

/**
 * The TenantTypes enum.
 */
export enum TenantTypesEnum {
  /**
   * Tenant Type enum: MSP
   */
  MSP = "MSP",

  /**
   * Tenant Type enum: MLSA
   */
  MLSA = "MLSA",

  /**
   * Tenant Type enum: MVP
   */
  MVP = "MVP",

  /**
   * Tenant Type enum: RD
   */
  RD = "RD",
}

/**
 * Sub site url root tenant paths
 */
export const SubSiteUrlRootPath = {
  mlsa: TenantTypesEnum.MLSA,
  rd: TenantTypesEnum.RD,
  mvp: TenantTypesEnum.MVP,
};
